import '../styles/App.css';
import 'leaflet/dist/leaflet.css';
import { Link } from 'react-router-dom';
import { Carousel } from "flowbite-react";

function App() {
  return (
    <>
      <div className="text-gray-200 text-center">
        <div className="p-10 text-5xl font-bold text-blue-600">Upload Your Catch!</div>
        <div>Upload your own catch <Link to="/upload_image" className="text-blue-400">here</Link>!</div>
      </div>

      <br></br>

      <div className="flex justify-center h-1/2">
        <div className="h-full w-1/2">
          <Carousel pauseOnHover indicators={false} slide={true}
          leftControl={<button className="p-6 bg-gray-800 text-gray-500 font-bold text-xl rounded-lg">{"<"}</button>}
          rightControl={<button className="p-6 bg-gray-800 text-gray-500 font-bold text-xl rounded-lg">{">"}</button>}>
            <img src="https://cdn.britannica.com/34/240534-050-B8C4B11E/Porcupine-fish-Diodon-hystox.jpg" alt="..." />
            <img src="https://www.aqueon.com/-/media/project/oneweb/aqueon/us/blog/ways-to-know-your-fish-are-happy/fish-are-happy-and-healthy-1.png" alt="..." />
            <img src="https://cdn.animalsaustralia.org/wp-content/uploads/2023/08/24170428/Batfish_parrotfish_reef_header-1900x600.jpg?theia_smart_thumbnails_file_version=2" alt="..." />
            <img src="https://cdn.petmojo.com/wp-content/uploads/2024/06/06111b29ec0441c83cd925c93229d9e8d10b43ed-1200x690-1.jpg" alt="..." />
            <img src="https://upload.wikimedia.org/wikipedia/commons/2/21/Celestial_eye_goldfish.jpg" alt="..." />
          </Carousel>
        </div>
      </div>

    </>
  );
}

export default App;
